<template lang="html">
  <div>
    <label class="gray--text">{{label}}{{this.required !== undefined ? '*' : ''}}</label>
    <p class="black--text body-1" :align="align"><pre class="black--text body-1">{{value}}</pre></p>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'align', 'required']
  }
</script>



// WEBPACK FOOTER //
// c-readonly-field-pre-format.vue?46540be7